import { atom, selector } from 'recoil';

export const warehouseObjState = atom({
  key: 'warehouse_obj',
  default: {
    address: {
      street: null,
      street2: null,
    },
  },
});

export const warehouseConfigState = atom({
  key: 'warehouse_config',
  default: {},
});
